import React from 'react';

const About = () => {
  return (
    <div>
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">About Janvahan</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Revolutionizing mobility in India with sustainable electric vehicles
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <p className="text-gray-600 mb-4 leading-relaxed">
              Founded in 2022, Janvahan emerged with a vision to transform India's urban mobility landscape. 
              We recognized the urgent need for sustainable transportation solutions that combine performance, 
              style, and environmental responsibility.
            </p>
            <p className="text-gray-600 mb-4 leading-relaxed">
              Today, we're proud to be at the forefront of India's electric vehicle revolution, offering 
              cutting-edge electric bikes that redefine the riding experience.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Our commitment goes beyond just manufacturing electric vehicles. We're building an ecosystem 
              that includes charging infrastructure, innovative battery technology, and exceptional customer service.
            </p>
          </div>
          <div className="bg-gray-100 rounded-lg h-96 flex items-center justify-center">
            <span className="text-gray-400">Company Image</span>
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12">Our Mission & Vision</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white shadow-lg rounded-lg p-8 text-center">
              <div className="text-5xl mb-4">🎯</div>
              <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
              <p className="text-gray-600">
                To accelerate India's transition to sustainable mobility by providing accessible, 
                reliable, and innovative electric vehicles that exceed customer expectations.
              </p>
            </div>
            <div className="bg-white shadow-lg rounded-lg p-8 text-center">
              <div className="text-5xl mb-4">👁️</div>
              <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
              <p className="text-gray-600">
                To become India's most trusted electric vehicle brand, leading the charge towards a 
                cleaner, greener, and more sustainable future for all.
              </p>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-3xl font-bold text-center mb-12">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="bg-red-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🔋</span>
              </div>
              <h3 className="font-bold mb-2">Innovation</h3>
              <p className="text-sm text-gray-600">Pushing boundaries of EV technology</p>
            </div>
            <div className="text-center">
              <div className="bg-red-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🌱</span>
              </div>
              <h3 className="font-bold mb-2">Sustainability</h3>
              <p className="text-sm text-gray-600">Committed to green future</p>
            </div>
            <div className="text-center">
              <div className="bg-red-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">❤️</span>
              </div>
              <h3 className="font-bold mb-2">Customer First</h3>
              <p className="text-sm text-gray-600">Your satisfaction is our priority</p>
            </div>
            <div className="text-center">
              <div className="bg-red-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">⭐</span>
              </div>
              <h3 className="font-bold mb-2">Excellence</h3>
              <p className="text-sm text-gray-600">Striving for perfection</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;